// extracted by mini-css-extract-plugin
export var sectionContainer = "TableModule-module--sectionContainer--2zLkt";
export var sectionContainerEmbedded = "TableModule-module--sectionContainerEmbedded--17OIy";
export var contentContainer = "TableModule-module--contentContainer--1TxH5";
export var centerContent = "TableModule-module--centerContent--3v4rf";
export var disclaimer = "TableModule-module--disclaimer--lq667";